/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_With_GoogleInputs */



/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Login_Continue_With_GoogleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_continue_with_google = /** @type {((inputs?: Login_Continue_With_GoogleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_With_GoogleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec Google")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Google fortfahren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua con Google")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить с Google")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar con Google")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续使用 Google")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Googleで続行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Google के साथ जारी रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar com o Google")
	return /** @type {LocalizedString} */ ("Continue with Google")
});